import { NgModule, ModuleWithProviders } from '@angular/core';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { JwtInterceptor } from './jwt.interceptor';
//import { ErrorInterceptor } from './error.interceptor';
@NgModule({
  imports: [HttpClientModule],
  exports: [HttpClientModule]
})

export class InterceptorsModule {
  static forRoot(): ModuleWithProviders<InterceptorsModule> {
    return {
      ngModule: InterceptorsModule,
      providers: [
        {
          provide: HTTP_INTERCEPTORS,
          useClass: JwtInterceptor,
          multi: true
        }
      ]
    };
  }
}
